import CollectionView from 'scripts/poppet/collection-view';
import ZoneSimpleView       from 'scripts/defa/zones/view-zone-simple-view';

/**
 * defa.views.ZoneCollectionView
 * A CollectionView for Zones.
 * @version 1.2.0
 */
const ZoneCollectionView = CollectionView.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	childView: ZoneSimpleView,
	
	childViewOptions: function() {
		return {
			settingsHome : this.options.settingsHome
		}
	},
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
} );

export default ZoneCollectionView;
